/**
 * Formats a string as a US phone number.
 * Only the first 10 digits of the input are considered.
 * @param input The input string to be formatted.
 * @returns A formatted phone number string.
 */
export const formatPhoneNumber = (input: string): string => {
  // Strip all non-digit characters
  const digitsOnly = input.replace(/\D/g, "");

  // Limit the string to 10 digits
  const trimmed = digitsOnly.substring(0, 10);

  // Match the numbers into groups
  const match = trimmed.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
  if (!match) return "";

  const [, areaCode, exchange, subscriber] = match;

  // Construct the phone number format
  let formattedNumber = "";
  if (areaCode) {
    formattedNumber = `${areaCode}`;
  }
  if (exchange) {
    formattedNumber += `-${exchange}`;
  }
  if (subscriber) {
    formattedNumber += `-${subscriber}`;
  }

  return formattedNumber;
};

export default formatPhoneNumber;
